
import type { EventCallback, TauriEvent, UnlistenFn } from '@tauri-apps/api/event'

import { CustomTauriEvent } from '@/shared/types/tauri'

const eventList = new Map<string, {
    isListing: boolean,
    listen: Promise<UnlistenFn>
}>()
export const useTauriEventListener = () => {
  const listenEvent = <T>(event : CustomTauriEvent | TauriEvent, listenHandler : EventCallback<T>) => {
    import('@tauri-apps/api/webviewWindow').then(({ getCurrentWebviewWindow }) => {
      eventList.set(event, {
        isListing: true,
        listen: getCurrentWebviewWindow().listen<T>(event, listenHandler),
      })
    })
  }

  const unListenEvent = async (event : CustomTauriEvent | TauriEvent) => {
    const listenEvent = eventList.get(event)
    if (listenEvent?.isListing) {
      const unlisten = await listenEvent.listen
      unlisten()
      eventList.delete(event)
    }
  }

  const getStatuslistenEvent = (event : CustomTauriEvent | TauriEvent) => {
    return eventList.get(event)?.isListing
  }

  return {
    listenEvent,
    unListenEvent,
    getStatuslistenEvent,
  }
}
